const PENDING_AUTH_RETURN_KEY = "zeastro-auth-return";

export function safeLocalReturnTo(value: string | null | undefined): string | null {
  if (!value || !value.startsWith("/") || value.startsWith("//")) return null;
  try {
    const parsed = new URL(value, "https://zeastro.local");
    if (parsed.origin !== "https://zeastro.local") return null;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return null;
  }
}

export function authReturnFromSearch(search: string): string | null {
  return safeLocalReturnTo(new URLSearchParams(search).get("returnTo"));
}

export function rememberAuthReturn(returnTo: string | null): void {
  if (!returnTo) return;
  try {
    sessionStorage.setItem(PENDING_AUTH_RETURN_KEY, returnTo);
  } catch {
    // Storage can be unavailable in private browsing; the URL still carries it.
  }
}

export function consumeRememberedAuthReturn(): string | null {
  try {
    const value = safeLocalReturnTo(sessionStorage.getItem(PENDING_AUTH_RETURN_KEY));
    sessionStorage.removeItem(PENDING_AUTH_RETURN_KEY);
    return value;
  } catch {
    return null;
  }
}

export function withAuthReturn(path: "/login" | "/signup", returnTo: string): string {
  return `${path}?returnTo=${encodeURIComponent(returnTo)}`;
}